import {CoreObjectId} from 'app-core/framework/CoreObjectConstants';
import {getApiBaseForObjectType, getObjectType} from 'app-core/framework/CoreObjectIntrospectionUtils';
import {ItemForArchive} from 'archive/ArchiveConstants';
import {DataModificationsHeader} from 'audit/DataModifications';
import {patchJSONPromise} from 'util/Net';
import {postJSON} from 'util/TaskRunner';

export function getItemsForArchive(
  itemIds: Array<string>,
  {shouldDetectShortcuts}: {shouldDetectShortcuts?: boolean}
): JQueryPromise<{itemsForArchive: Array<ItemForArchive>}> {
  return postJSON({
    url: '/1/api/archive:get-items-for-archive',
    data: {itemIds, shouldDetectShortcuts},
  });
}

export interface ArchiveItemsResponse {
  updatedIds: Array<CoreObjectId>;
}

/**
 * Modern Core Object implementation of archive request.
 */
export function archiveItems(
  ids: Array<CoreObjectId>,
  archiveReason: String,
  dataModsHeader?: DataModificationsHeader
): Promise<ArchiveItemsResponse> {
  // TODO: Check or otherwise handle ids of varying types.
  const updates = ids.map((id) => ({
    id,
    isArchived: true,
    archiveReason,
  }));

  return patchJSONPromise({
    url: getApiBaseForObjectType(getObjectType({id: ids[0]})),
    data: {updates},
    extraHeaders: dataModsHeader,
  });
}

export interface UnarchiveItemsResponse {
  updatedIds: Array<CoreObjectId>;
}

/**
 * Modern Core Object implementation of unarchive request.
 */
export function unarchiveItems(
  ids: Array<CoreObjectId>,
  dataModsHeader?: DataModificationsHeader
): Promise<UnarchiveItemsResponse> {
  // TODO: Check or otherwise handle ids of varying types.
  const updates = ids.map((id) => ({id, isArchived: false}));
  return patchJSONPromise({
    url: getApiBaseForObjectType(getObjectType({id: ids[0]})),
    data: {updates},
    extraHeaders: dataModsHeader,
  });
}
